import { useEffect } from 'react';

import { SkeletonProductsFeed } from '@components/SkeletonProductsFeed';
import { ConversionTopSellerProducts } from '@components/ConversionTopSellerProducts';
import { renderProductCards } from '@utils/products';
import {
  ClerkActionType,
  ClerkCategoryType,
  ClerkShowTopSellerProductsBlockEvent,
  ClerkSourceType,
  useClerk,
} from '@hook/useClerk';

import { useConversionTopSellerProductsQuery } from './graphql.v3.generated';

export const ConversionTopSellerProductsContainer: React.FC = () => {
  const { sendClerkEvent } = useClerk();

  const { data, loading } = useConversionTopSellerProductsQuery({
    variables: {
      first: 30,
    },
  });

  useEffect(() => {
    sendClerkEvent<ClerkShowTopSellerProductsBlockEvent>({
      category: ClerkCategoryType.topSellerProducts,
      action: ClerkActionType.show,
      payload: {
        source: ClerkSourceType.personalTopSellerProductsBlock,
      },
    });
  }, [sendClerkEvent]);

  if (loading && !data) {
    return (<SkeletonProductsFeed count={30} />);
  }

  if (data?.topSellerProducts) {
    const productsList = renderProductCards(data.topSellerProducts.edges || []);
    return (
      <ConversionTopSellerProducts
        products={productsList || []}
      />
    );
  }
  return null;
};
